import React from "react";
import { Box, Heading, Stack, Button, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

const Home: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Stack
      minH="100vh"
      alignItems="center"
      justifyContent="center"
      bgGradient="linear(to-b, #e0eafc, #cfdef3)"
      p={4}
      position="relative"
    >
      <Heading size="2xl" color="#01579b" mb={2}>
        Cricket Toss Design Hub
      </Heading>
      <Text fontSize="xl" color="#333" mb={4} textAlign="center">
        Choose a new way to decide the toss or reveal the result!
      </Text>
      <Stack direction={{ base: "column", md: "row" }} alignItems="stretch">
        <Box
          bg="#fff"
          borderRadius="2xl"
          boxShadow="xl"
          p={8}
          minW={280}
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          <Heading size="md" color="#2b6cb0" mb={2}>
            🪙 Coin the Toss
          </Heading>
          <Text mb={4} color="gray.600">
            Flip a classic coin to decide the toss—simple, fast, and fair!
          </Text>
          <Button colorScheme="blue" onClick={() => navigate("/coin-toss")}>
            Try Coin Toss
          </Button>
        </Box>
        <Box
          bg="#fff"
          borderRadius="2xl"
          boxShadow="xl"
          p={8}
          minW={280}
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          <Heading size="md" color="#2b6cb0" mb={2}>
            🥇 Bat or Ball Wheel
          </Heading>
          <Text mb={4} color="gray.600">
            Spin a wheel to randomly select Bat or Ball. Adds excitement and
            fairness to the toss!
          </Text>
          <Button colorScheme="teal" onClick={() => navigate("/wheel")}>
            Try Wheel
          </Button>
        </Box>
        <Box
          bg="#fff"
          borderRadius="2xl"
          boxShadow="xl"
          p={8}
          minW={280}
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          <Heading size="md" color="#2b6cb0" mb={2}>
            🥈 Bat Flip
          </Heading>
          <Text mb={4} color="gray.600">
            Simulate the real-world bat flip used in cricket leagues. Will it
            land on Bat or Ball?
          </Text>
          <Button colorScheme="orange" onClick={() => navigate("/bat-flip")}>
            Try Bat Flip
          </Button>
        </Box>
        <Box
          bg="#fff"
          borderRadius="2xl"
          boxShadow="xl"
          p={8}
          minW={280}
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          <Heading size="md" color="#2b6cb0" mb={2}>
            🥉 Commentary Reveal
          </Heading>
          <Text mb={4} color="gray.600">
            Reveal the toss result with a dramatic cricket-style commentary!
          </Text>
          <Button colorScheme="purple" onClick={() => navigate("/commentary")}>
            Try Commentary
          </Button>
        </Box>
      </Stack>
      <Button
        position="absolute"
        top={4}
        right={4}
        variant="ghost"
        colorScheme="teal"
        borderRadius="full"
        p={2}
        minW={0}
        onClick={() => navigate("/")}
        aria-label="Go back to home"
      >
        <Box as="span" fontSize="2xl">
          🏠
        </Box>
      </Button>
    </Stack>
  );
};

export default Home;
